import { Component, DestroyRef, inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SQWADService } from '@fgb/core';
import { TranslateService } from '@ngx-translate/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'fgb-player-reveal-page',
  templateUrl: './player-reveal-page.component.html',
  styleUrls: ['./player-reveal-page.component.scss'],
})
export class PlayerRevealPageComponent implements OnInit {
  playerRevealURL: string;
  screenType = ScreenType;
  private destroyRef = inject(DestroyRef);
  @ViewChild('gameCallback') gameCallback: TemplateRef<any>;

  constructor(private sqwadService: SQWADService, private translate: TranslateService) {}

  ngOnInit(): void {
    this.playerRevealLink();
  }

  launchGame(url: string) {
    this.sqwadService.sso(1, url);
  }

  playerRevealLink() {
    this.translate
      .stream('player.reveal.url')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: string) => {
        this.playerRevealURL = data;
      });
  }
}
